import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

export const FilterDrawerMobile = styled(animated.div)`
  position: fixed;
  background: rgba(0, 0, 0, 0.75);
  /* position: fixed; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  overflow-y: auto;
`;
export const FiltersContainer = styled(animated.div)`
  ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.canvas200 &&
    css`
      ::-webkit-scrollbar {
        width: 6px;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.18);
        border-radius: 999px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.32);
      }
    `}
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow-y: auto;
`;

export const FilterDrawerWrapper = styled(animated.div)`
  ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.canvas200 &&
    css`
      ::-webkit-scrollbar {
        width: 6px;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.18);
        border-radius: 999px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.32);
      }
    `}
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  width: 100%;
  right: 0;
  z-index: 99;
  inset: 0px;
  @media ${device.laptop} {
    position: sticky;
    width: auto;
    top: -1px;
  }
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.sidebarTablet ?? COLORS.white};
  position: relative;
  @media ${device.tablet} {
    width: 374px;
  }
  @media ${device.laptop} {
    background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
      theme.sidebarDesktop ?? COLORS.white};
  }
  @media ${device.laptopMd} {
    width: 100%;
  }
`;

export const FilterHeadWrapper = styled.div`
  padding: 20px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  position: sticky;
  width: auto;
  height: auto;
  top: 0;
  background: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.sidebarTablet ?? COLORS.white};
  z-index: 100;
  /* width: 360px; */
  box-shadow:
    0px 6px 6px -6px rgba(0, 0, 0, 0.2),
    0px 3px 4px -3px rgba(0, 0, 0, 0.1);

  @media ${device.laptop} {
    padding: 20px 24px 20px 48px;
    position: initial;
    box-shadow: none;
    width: auto;
    background: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
      theme.sidebarDesktop ?? COLORS.white};
  }
`;

export const TitleAndClose = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const FiltersList = styled.div<{ isReachedEndOfContainer: boolean; isPassedNav: boolean }>`
  padding: 0 12px 12px 12px;
  @media ${device.laptopMd} {
    padding: 0 24px 24px 24px;
    padding-bottom: ${({ isReachedEndOfContainer }) => (isReachedEndOfContainer ? '24px' : '24px')};
    margin-bottom: ${({ isPassedNav }) => (isPassedNav ? 0 : '78px')};
  }
`;

export const HideFilters = styled.button`
  border: none;
  background: initial;
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
  svg path {
    stroke: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
      theme.foregroundNeutral100 ?? 'currentColor'};
  }
`;

export const Title = styled.h2`
  font-family: Audi Type Extended;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.002px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
`;

export const Filter = styled.div<{ showFilter?: boolean }>``;

export const ExposedButton = styled.div`
  padding: 16px 24px;
  border-top: 1px solid
    ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.borderSubtle ?? COLORS.grey15};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
`;

export const FilterHeader = styled.div`
  width: 100%;
`;

export const FilterTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  font-family: Audi Type;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const FilterListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
`;

export const GreenDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${COLORS.spaceInvader};
  margin-top: 6px;
`;

export const FilterList = styled.div`
  max-width: 93%;
`;

export const BadgeWrapper = styled.div`
  margin-top: 4px;
  span {
    font-family: 'Audi Type Variable', sans-serif;
    font-size: 14px;
  }
`;

export const FilterSectionLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FilterSelection = styled(animated.div)<{ setPaddings?: boolean }>`
  background-color: rgba(0, 0, 0, 0.05);
  padding: ${({ setPaddings }) => setPaddings && '24px'};
`;

export const FilterFrame = styled(animated.div)`
  padding: 0 16px 20px 16px;
`;

export const Disclaimer = styled.div`
  padding-bottom: 12px;
`;

export const GroupWrapper = styled.div<{ fullWidth?: boolean }>`
  display: grid;
  grid-template-columns: ${({ fullWidth }) => (fullWidth ? 'none' : 'repeat(2, 1fr)')};
  row-gap: 24px;
`;
